import { Button } from "components/Button"
import { useTranslator } from "components/Translator"
import {
  Comments,
  PhoneAlt,
  At,
  MousePointer,
  Whatsapp,
  Skype,
} from "components/Icon"
import { RequireClub } from "components/RequireClub"
import { Text } from "components/Text"
import { replaceAll } from "utils/replaceAll"
import * as React from "react"

const getPhoneHref = (phone) => {
  return `tel:${replaceAll(phone.formatted, " ", "")}`
}

export const ContactMethods = ({
  user,
  advert,
  shouldRequireClub,
  canSendDirectMessage,
  onDirectMessageClick,
}) => {
  const translator = useTranslator()

  const [showOtherContactMethods, setShowOtherContactMethods] =
    React.useState(false)

  const otherContactMethodsTitle = translator.trans(
    "ProfilePage.contactMethods.otherContactMethods",
    null,
    "components",
  )

  const directMessageButton = (
    <Button
      color="secondary"
      type="button"
      onClick={onDirectMessageClick}
      iconLeft={<Comments className="w-4" />}
      key={"direct-message"}
    >
      {translator.trans(
        "ProfilePage.contactMethods.directMessage",
        null,
        "components",
      )}
    </Button>
  )

  const phone = advert?.contactPhone ?? user.phone
  const email = advert?.contactEmail ?? user.email

  const methods = [
    canSendDirectMessage ? (
      shouldRequireClub ? (
        <RequireClub key={"direct-message"}>{directMessageButton}</RequireClub>
      ) : (
        directMessageButton
      )
    ) : null,
    phone ? (
      <Button
        href={getPhoneHref(phone)}
        variant="outline"
        color="secondary"
        iconLeft={<PhoneAlt className="w-4" />}
        key={"phone"}
      >
        {phone.formatted}
      </Button>
    ) : null,
    user.mobile ? (
      <Button
        href={getPhoneHref(user.mobile)}
        variant="outline"
        color="secondary"
        iconLeft={<PhoneAlt className="w-4" />}
        key={"mobile"}
      >
        {user.mobile.formatted}
      </Button>
    ) : null,
    email ? (
      <Button
        href={`mailto:${email}`}
        variant="outline"
        color="secondary"
        iconLeft={<At className="w-4" />}
        key={"email"}
      >
        {email}
      </Button>
    ) : null,
    user.website ? (
      <Button
        href={user.website}
        external
        variant="outline"
        color="secondary"
        iconLeft={<MousePointer className="w-3" />}
        key={"website"}
      >
        {translator.trans(
          "ProfilePage.contactMethods.website",
          null,
          "components",
        )}
      </Button>
    ) : null,
    user.whatsApp ? (
      <Button
        href={`https://wa.me/${user.whatsApp.formatted.replaceAll(" ", "")}`}
        external
        variant="outline"
        color="secondary"
        iconLeft={<Whatsapp className="w-4" />}
        key={"whatsapp"}
      >
        {translator.trans(
          "ProfilePage.contactMethods.whatsapp",
          null,
          "components",
        )}
      </Button>
    ) : null,
    user.skype ? (
      <Button
        href={`skype:${user.skype}`}
        external
        variant="outline"
        color="secondary"
        iconLeft={<Skype className="w-4" />}
        key={"skype"}
      >
        {translator.trans(
          "ProfilePage.contactMethods.skype",
          null,
          "components",
        )}
      </Button>
    ) : null,
    advert && advert.contactOther ? (
      advert.contactOther.startsWith("http") ? (
        <Button
          href={advert.contactOther}
          external
          variant="outline"
          color="secondary"
          key={"other"}
        >
          {advert.contactOther}
        </Button>
      ) : (
        <Text
          className="text-center text-primary-dark"
          variant="button"
          key={"other"}
        >
          {advert.contactOther}
        </Text>
      )
    ) : null,
  ].filter((method) => method !== null)

  const mainMethods = methods.slice(0, 2)
  const otherMethods = methods.slice(2)

  return (
    <div className="flex flex-col space-y-4">
      {mainMethods}
      {otherMethods.length > 0 ? (
        showOtherContactMethods ? (
          otherMethods
        ) : (
          <Button
            color="secondary"
            variant="outline"
            onClick={() => setShowOtherContactMethods(true)}
          >
            {otherContactMethodsTitle}
          </Button>
        )
      ) : null}
    </div>
  )
}
